export default __webpack_public_path__ + "static/media/storePickupIcon.7371ef51.png";